import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { DesignContextForwardProvider, useDesignContext } from '@klarna/designtokens';
import useTextStyle from '@bubble-ui/hook-use-text-style';
import TextPrimitive from '@bubble-ui/primitive-text';
import usePropDeprecationWarning from '@bubble-ui/hook-use-prop-deprecation-warning';
import { isNative } from '@bubble-ui/util-platform';
import { getAccessibilityPresetAttrs } from './accessibilityPresets';
import { defaultDesignTokens } from './defaultDesignTokens';
var getDisplayName = element => {
  var _element$type;
  return (// @ts-expect-error
    element === null || element === void 0 ? void 0 : (_element$type = element.type) === null || _element$type === void 0 ? void 0 : _element$type.displayName
  );
};
var Typography = _ref => {
  var {
    accessibilityPreset = 'none',
    align,
    children,
    colorToken = 'typography/text-color',
    colorTokenArgs,
    direction,
    id,
    numberOfLines = 0,
    testID,
    textDecorationLine,
    textToken = 'typography/text-style',
    textTokenArgs,
    textAlignToken = 'typography/text-alignment',
    textAlignTokenArgs,
    UNSAFE_props
  } = _ref;
  usePropDeprecationWarning({
    componentName: 'Typography',
    propName: 'align',
    shouldWarn: align !== undefined,
    removalDate: 'v6.0.0',
    useInstead: 'textAlignToken'
  });
  var designContext = useDesignContext(defaultDesignTokens);
  var accPresetAttributes = getAccessibilityPresetAttrs(accessibilityPreset);
  var textStyle = useTextStyle({
    align,
    colorToken,
    colorTokenArgs,
    designTokens: defaultDesignTokens,
    direction,
    numberOfLines,
    textDecorationLine,
    textToken,
    textTokenArgs,
    textAlignToken,
    textAlignTokenArgs
  });
  var nativeAttrs =
  // Ellipsis styling for web is handled by useTextStyle 👆
  isNative ? {
    numberOfLines,
    ellipsizeMode: 'tail'
  } : {};
  return /*#__PURE__*/React.createElement(TextPrimitive, _extends({
    id: id,
    testID: testID
  }, UNSAFE_props, accPresetAttributes, nativeAttrs, {
    style: textStyle
  }), React.Children.map(children, child => {
    if (! /*#__PURE__*/React.isValidElement(child) || typeof child !== 'object') {
      return child;
    }
    var childAsElement = child;
    var finalColorToken = childAsElement.props.colorToken || colorToken;
    var finalColorTokenArgs = childAsElement.props.colorTokenArgs || colorTokenArgs;
    var finalTextToken = childAsElement.props.textToken || textToken;
    var finalTextTokenArgs = childAsElement.props.textTokenArgs || textTokenArgs;
    if (getDisplayName(child) === 'Typography') {
      return /*#__PURE__*/React.createElement(DesignContextForwardProvider, {
        context: designContext
      }, /*#__PURE__*/React.cloneElement(childAsElement, {
        colorToken: finalColorToken,
        colorTokenArgs: finalColorTokenArgs,
        textToken: finalTextToken,
        textTokenArgs: finalTextTokenArgs
      }));
    } else if (getDisplayName(child) === 'Link') {
      return /*#__PURE__*/React.createElement(DesignContextForwardProvider, {
        context: designContext
      }, /*#__PURE__*/React.cloneElement(childAsElement, {
        colorTokenArgs: finalColorTokenArgs,
        textToken: finalTextToken,
        textTokenArgs: finalTextTokenArgs
      }));
    } else if (getDisplayName(child) === 'List') {
      return /*#__PURE__*/React.createElement(DesignContextForwardProvider, {
        context: designContext
      }, /*#__PURE__*/React.cloneElement(childAsElement, {
        colorToken: finalColorToken,
        colorTokenArgs: finalColorTokenArgs,
        textToken: finalTextToken,
        textTokenArgs: finalTextTokenArgs
      }));
    }
    return child;
  }));
};
Typography.displayName = 'Typography';
export default Typography;
//# sourceMappingURL=index.js.map